/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { URLS } from '../../../../../constants/urls.constants';
import { useApiRequest, IResponsePayload } from '../../../../../hooks/useApiRequest';
import { setLoading, stopLoading } from '../../../../../store/modules/loading';
import { setAlert } from '../../../../../store/modules/snackbar';
import { IGetSupervisionUnit } from '../../interfaces/get-supervision-unit.interface';

interface IUpdateUIRelations {
	setValue: React.Dispatch<
		React.SetStateAction<IResponsePayload<IGetSupervisionUnit> | null>
	>;
}

export const useUpdateUIRelations = ({ setValue }: IUpdateUIRelations) => {
	const dispatch = useDispatch();

	const {
		execute: updateUIRelations,
		status: statusUpdateUIRelations,
		value: valueUpdateUIRelations,
	} = useApiRequest<unknown, IResponsePayload<IGetSupervisionUnit>>({
		path: URLS.PROJECT.MANY_SUPERVISION_UNIT,
		method: 'POST',
	});

	useEffect(() => {
		if (statusUpdateUIRelations === 'success') {
			dispatch(stopLoading());
			dispatch(
				setAlert({
					show: true,
					message: 'Información actualizada con éxito',
					severity: 'success',
				})
			);
			setValue(valueUpdateUIRelations);
		} else if (statusUpdateUIRelations === 'error') {
			dispatch(stopLoading());
			dispatch(
				setAlert({
					show: true,
					message: 'Ocurrió un error al actualizar el proyecto',
					severity: 'error',
				})
			);
		}
	}, [statusUpdateUIRelations]);

	const handleUpdateUIRelations = (body: { supervisionUnits: any }) => {
		dispatch(setLoading({ loading: true }));
		updateUIRelations(body);
	};

	return { handleUpdateUIRelations };
};
